import React, { useState } from 'react'
import { Button, Typography, Alert, Checkbox } from 'components'
import { useNavigate } from 'react-router-dom'
import { URL_CONST } from 'constants/urls'
import ReactCodeInput from 'react-code-input'
import { useDispatch, useSelector } from 'store/store'
import { setLoginValidation } from 'store/StructuralContext/structuralSlice'
import {
  clearState,
  handleConfirmAuth,
  resendAuthCode
} from 'store/AuthContext/authSlice'
import { revertBooleanApiValue } from 'commons/utils/boolean'

import * as S from './styles'

const ValidateLogin: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [code, setCode] = useState<string>('')
  const [checkedPersist, setCheckedPersist] = useState<boolean>(true)
  const [showInvalidCodeError, setShowInvalidCodeError] = useState<boolean>(false)
  const isButtonDisabled = code === '' || code.length < 6

  const { authData, email, isLoading } = useSelector((state) => state.auth)

  const handleInputChange = (value: string) => {
    setShowInvalidCodeError(false)
    setCode(value)
  }

  const handleResendCode = async () => {
    dispatch(resendAuthCode({ ...authData, fl_renv_cod: revertBooleanApiValue(true) }))
  }

  const handleReturn = () => {
    dispatch(setLoginValidation(false))
    dispatch(clearState())
  }

  const handleValidateCode = async (event: React.FormEvent) => {
    event.preventDefault()
    dispatch(
      handleConfirmAuth(
        {
          ...authData,
          ds_cod_senh: code,
          fl_extn_temp_auth: revertBooleanApiValue(checkedPersist)
        },
        () => navigate(URL_CONST.ROOT),
        () => setShowInvalidCodeError(true)
      )
    )
  }

  return (
    <form onSubmit={handleValidateCode} autoComplete="true">
      <S.FieldsWrapper>
        <Typography className="title" design="hav-h5-text">
          Verificação
        </Typography>

        <Typography className="description">
          Insira o código <br />
          que foi enviado para o e-mail:
          <br />
          <strong>{email.toLocaleLowerCase()}</strong>
          <br />
          nos campos abaixo.
        </Typography>
        {showInvalidCodeError && (
          <S.ErrorWrapper>
            <Alert
              kind="error"
              fullWidth
              title="Código incorreto."
              message="Verifique o código digitado e tente novamente."
            />
          </S.ErrorWrapper>
        )}
        <ReactCodeInput
          name="code"
          inputMode="latin"
          forceUppercase
          fields={6}
          type="text"
          onChange={handleInputChange}
          placeholder="-"
          isValid={!showInvalidCodeError}
          inputStyle={{
            height: '40px',
            width: '40px',
            borderRadius: '5px',
            border: '1px solid #BCBCBC',
            marginRight: '10px',
            textAlign: 'center'
          }}
          inputStyleInvalid={{
            border: '1px solid #FF0000',
            height: '40px',
            width: '40px',
            borderRadius: '5px',
            margin: '2.5px',
            textAlign: 'center'
          }}
        />
      </S.FieldsWrapper>
      <Checkbox
        size="small"
        label="Manter verificação por 1 semana"
        checked={checkedPersist}
        onChange={() => setCheckedPersist((prev) => !prev)}
      />
      <S.ButtonWrapper>
        <Button
          fullWidth
          content="Confirmar"
          type="submit"
          loading={isLoading}
          disabled={isButtonDisabled}
        />
        <Button
          fullWidth
          content="Voltar"
          color="secondary"
          active
          onClick={handleReturn}
        />
      </S.ButtonWrapper>
      <S.ResendCode onClick={handleResendCode}>Reenviar código</S.ResendCode>
    </form>
  )
}

export default ValidateLogin
